var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortalysLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2744_1035)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    stroke: "white",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 16.0399V28.04C15.4087 28.04 13.8826 27.4078 12.7574 26.2826C11.6321 25.1574 11 23.6312 11 22.0399C11 20.4486 11.6321 18.9225 12.7574 17.7973C13.8826 16.672 15.4087 16.0399 17.0001 16.0399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 16.0001C16.9999 12.6863 19.6862 10 22.9999 10C26.3137 10 29 12.6863 29 16.0001V28.0002C29 31.3139 26.3137 34.0002 22.9999 34.0002C19.6995 34.0002 17.0216 31.3353 17.0001 28.04C20.3137 28.0399 22.9999 25.3538 22.9999 22.0401C22.9999 18.7264 20.3138 16.0399 17.0001 16.0399L16.9999 16.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2744_1035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalysLogo);
export default __webpack_public_path__ + "static/media/portalysLogo.4c1d9ecd17a0df44c9d228213522a14a.svg";
export { ForwardRef as ReactComponent };